import React from "react";
import "./MultiDimensionalColumnRenderer.css";

const MdvTooltipContent = ({ value, colDef }) => {
  const formatTimeSeriesValue = (propValue, block) => {
    if (block === "timeseries" && typeof propValue === "string" && !isNaN(propValue) && propValue !== "") {
      const numberValue = parseFloat(propValue);
      const hours = Math.floor(numberValue);
      const decimalPart = propValue.split(".")[1] || "0";
      const minutes = parseInt(decimalPart, 10);
      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }
    return propValue;
  };

  return (
    <table className="tooltip-table">
      <tbody>
        {Array.isArray(value) &&
          value.map((item) => {
            const formattedValue = formatTimeSeriesValue(item.propValue, colDef.block);
            return (
              <tr key={item.propName} className="tooltip-row">
                <td className="tooltip-name">
                  {`${item.propName} [${item.propAbbrevation.toUpperCase()}]`}
                </td>
                <td className="tooltip-value">
                  {colDef.block === "timeseries" &&
                  ["PT", "AT", "WH"].includes(item.propAbbrevation)
                    ? formattedValue : item.propValue && Array.isArray(item.propValue) ? item.propValue.join(', ') : item.propValue}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default MdvTooltipContent;
